import React from 'react';
import { motion } from 'framer-motion';
import { CoffeeIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
export function FinalCta() {
  return <section className="relative overflow-hidden border-b border-carbon-800 bg-carbon-950 py-24" id="comprar" data-id="element-29" data-mp="19f7ex64rcfdw">
      <div className="bg-grid absolute inset-0" aria-hidden="true" data-id="element-30" data-mp="15caqgysjdp21" />
      <div className="absolute bottom-[-160px] left-1/2 h-80 w-[36rem] -translate-x-1/2 rounded-full bg-safety/10 blur-[120px]" aria-hidden="true" data-id="element-31" data-mp="1jcvd661ko50t" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="relative mx-auto max-w-3xl px-5 text-center sm:px-8" data-id="element-32" data-mp="1ebxrhjhcssuk">
        <span className="inline-flex items-center gap-2 rounded-full border border-carbon-700 bg-carbon-850 px-3 py-1.5 text-xs font-semibold text-slate-400" data-id="element-33" data-mp="223wayqqyhuis">
          <CoffeeIcon className="h-4 w-4 text-safety" aria-hidden="true" data-id="element-34" data-mp="n6dz559fxnog" />
          Menos de lo que cuesta un café con algo
        </span>

        <h2 className="mt-6 text-3xl font-black leading-tight tracking-tight text-white sm:text-5xl" data-id="element-35" data-mp="s6s063cmjxcz">
          Profesionaliza tu taller hoy por el costo de un café.
        </h2>
        <p className="mt-5 text-base leading-relaxed text-slate-400 sm:text-lg" data-id="element-36" data-mp="124g85uz8r1d3">
          {PRICE} una sola vez. Descarga inmediata, actualizaciones incluidas y la próxima falla
          resuelta en minutos en vez de horas.
        </p>

        <div className="mt-9 flex justify-center" data-id="element-37" data-mp="1b173u69vse75">
          <CtaButton label="Comprar ahora en Hotmart" data-id="element-38" data-mp="1fvl0sd46ytdx" />
        </div>
      </motion.div>
    </section>;
}